// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__l2oNM","blue":"loading_blue__rsj7d"};